export const TERM_CLASSIFICATION_OPTIONS = [
  { value: 'first_semester', label: '1학기' },
  { value: 'summer_intensive', label: '여름특강' },
  { value: 'second_semester', label: '2학기' },
  { value: 'winter_intensive', label: '겨울특강' },
];
export function classificationLabel(type) {
  return TERM_CLASSIFICATION_OPTIONS.find(item => item.value === type)?.label || '기타 (기존)';
}
export function sortCourseTerms(terms) {
  const order = type => {
    const index = TERM_CLASSIFICATION_OPTIONS.findIndex(item => item.value === type);
    return index < 0 ? 4 : index;
  };
  return [...terms].sort((a,b) => b.academicYear - a.academicYear || order(a.termType) - order(b.termType) || String(a.id).localeCompare(String(b.id)));
}
export function classificationPayload(item, existing = false) {
  if (!Number.isInteger(item.academicYear) || item.academicYear < 2000 || item.academicYear > 2200 ||
    (!TERM_CLASSIFICATION_OPTIONS.some(option => option.value === item.termType) && !(existing && item.termType === 'other')))
    throw new Error('연도와 학기 구분을 확인해 주세요.');
  return { setting_id: existing ? item.id : null, setting_academic_year: item.academicYear,
    setting_term_type: item.termType, setting_is_active: item.active !== false };
}
